import React from 'react';
import Header from './Header';

const Layout = ({ children, signOut, user }) => {
  return (
    <div className="app-layout">
      <Header signOut={signOut} user={user} />
      <main className="main-content" style={{ backgroundColor: '#FFFFFF', minHeight: 'calc(100vh - 56px)' }}>
        {children}
      </main>
    </div>
  );
};

export default Layout;